import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-message-modal',
  templateUrl: './message-modal.component.html',
  styleUrls: ['./message-modal.component.scss']
})
export class MessageModalComponent implements OnInit {

  message: string;

  constructor(
    public dialogRef: MatDialogRef<MessageModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {}

  onNoClick(option:any): void {
    console.log("Modal Click Result: ", option);
    this.dialogRef.close(option);
  }

  validateMessage(message){
    if (message == null){
      return false;
    }
    return true;
  }

  ngOnInit(): void {
    this.message = this.data;
  }

}

